import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar'; 
import Footer from './Footer'; 

const PageContainer = ({ children }) => {
  const location = useLocation();
  const hideNavbarRoutes = ['/landingPage', '/recommendationsLanding', '/teachersLanding'];

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Box flex="1" mt={!hideNavbarRoutes.includes(location.pathname) ? '8vh' : '0'}> 
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default PageContainer;
